/**
 *
 * States
 *
 */

import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import {
  Breadcrumb,
  Layout,
  Spin,
  Card,
  Result,
  Button,
  Row,
  Col,
  Tag
} from "antd";
import LeadContext from "../../contexts/leads";
import Navbar from "../../components/navbar";
import State from "../../components/maps/state";
import Leads from "../../components/leads";
import "./styles.css";
import india from "../../utils/images/india.svg";
import "./styles.css";
const { Header, Content } = Layout;

export function States({ props }) {
  const [data, setData] = useState({ districts: [] });
  const [leadCount, setLeadCount] = useState({ count: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { supplyApi } = useContext(LeadContext);

  const heading = props.match.params.state
    .replace(/[^A-Za-z]+/g, " ")
    .toLowerCase()
    .slice(1)
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toDistrict = slug => {
    window.location.href = `/${props.match.params.state}/${slug}`;
  };

  const loadData = () => {
    setLoading(true);
    supplyApi
      .get(
        `states/${props.match.params.state}/`
      )
      .then(response => {
        setData({ districts: response.data });
        loadLeadCount(response.data.id);
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
      });
  };

  const loadLeadCount = id => {
    setLoading(true);
    supplyApi
      .get(
        `leads/count/?state_id=${id}`
      )
      .then(response => {
        setLeadCount({ count: response.data.leads });
        setLoading(false);
      })
      .catch(err => {
        setError(true);
        setLoading(false);
      });
  };

  if (loading) {
    return <Spin spinning={!loading} />;
  }

  if (error) {
    return (
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <>
            <Button type="primary" onClick={() => (window.location.href = "/")}>
              Home
            </Button>
            <Button type="primary" onClick={() => (window.location.href = "/")}>
              Another Location
            </Button>
          </>
        }
      />
    );
  }

  if (data.districts.districts.length > 0) {
    var districts = data.districts.districts.sort(function(a, b) {
      return a.name.localeCompare(b.name);
    });

    const title = (
      <Breadcrumb>
        <Breadcrumb.Item href="/">
          <span>
            <img src={india} alt="india" style={{ height: 35, width: 35 }} />
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{heading}</Breadcrumb.Item>
      </Breadcrumb>
    );

    return (
      <div>
        <Helmet>
          <title>Zo Supply | {heading}</title>
        </Helmet>
        <Header className="header">
          <Navbar />
        </Header>
        <Content className="content">
          <Card title={title}>
            <div>
              <Leads id={data.districts.id} props={props.match.params.state} />
            </div>
            <div style={{ height: "50vh" }}>
              <State geometry={data.districts.geometry} />
            </div>
            {districts.map(district => {
              return (
                <Card.Grid
                  key={district.id}
                  className="gridStyle"
                  onClick={() => toDistrict(district.slug)}
                >
                  <Row>
                    <Col span={18}>{district.name}</Col>
                    <Col span={6}>
                      {leadCount.count.find(
                        x => x.district_id === district.id
                      ) ? (
                        <Tag style={{ marginLeft: 5 }} color="blue">
                          {
                            leadCount.count.find(
                              x => x.district_id === district.id
                            ).count
                          }
                        </Tag>
                      ) : (
                        <Tag style={{ marginLeft: 5 }} color="red">
                          NA
                        </Tag>
                      )}
                    </Col>
                  </Row>
                </Card.Grid>
              );
            })}
          </Card>
        </Content>
      </div>
    );
  }
  return null;
}

export default States;
